import { Component, Input,  OnInit } from '@angular/core';
import { NgbModal, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { FormArray, FormBuilder, FormGroup, Validators, SelectMultipleControlValueAccessor } from '@angular/forms';
import { first } from 'rxjs/operators';
import { NgxSpinnerService } from 'ngx-spinner';
import { ClientService } from 'src/app/parametrage/core/service/client.service';
import { Client } from 'src/app/parametrage/core/model/client';

@Component({
  selector: 'app-edit-client',
  templateUrl: './edit-client.component.html',
  styleUrls: ['./edit-client.component.css']
})
export class EditClientComponent implements OnInit {

  @Input() clientId;

  client : Client;

  form2: FormGroup;
  pressButton:Boolean = false;

  errorMessage:String = null;

  
  
  constructor( private _router: Router,
    private _activatedRoute: ActivatedRoute, 
    private fb: FormBuilder,
    public activeModal: NgbActiveModal,
    private spinner: NgxSpinnerService,
    private _clientService: ClientService) 
    { 
      this.createForm();
    }

    createForm() 
    {
        this.form2 = this.fb.group({
          nomClient: [null, Validators.compose([Validators.required])]
        });
    }


    

    ngOnInit() {
      this.getClientById(this.clientId)
    }
  
    
    getClientById(actifId)
    {
         this._clientService.getClientById(actifId)
         .subscribe(
             data => {
               debugger
               this.client =  data;
             },
             error => {
               console.log(error);
             });
    }
  
    
    edit(): void {
        
      this.spinner.show();
          this._clientService.updateClient(this.client)
          .pipe(first())
              .subscribe(
                  data => {
                    this.spinner.hide();
                    this.activeModal.close();
                    ;
                  },
                  error => {
                    console.log(error);
                    this.spinner.hide();
              });
    } 
  
  
  
  
      
  

}
